export default __webpack_public_path__ + "static/media/telkomsel-logo-white.b78312af.png";